module.exports = __webpack_public_path__ + "static/media/dispensary.cdf58213.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pins/dispensary.svg
// module id = 420
// module chunks = 0